import { Banner, Button } from '../ds/components';
import { ApiError, errorMessage } from '../lib/api';
import { AuthFrame } from '../modules/auth/AuthFrame';
import styles from './LoadErrorPage.module.css';

/** The session could not be loaded (Deal-Pipeline 15 pattern: danger banner with "Erneut laden"). */
export function LoadErrorPage({ error, onRetry }: { error: unknown; onRetry: () => void }) {
  const status = error instanceof ApiError ? error.status : null;
  return (
    <AuthFrame>
      <Banner
        tone="danger"
        actions={
          <Button variant="destructiveFilled" size="small" onClick={onRetry}>
            Erneut laden
          </Button>
        }
      >
        <span className={styles.text}>
          Die Anmeldung konnte nicht geladen werden{status !== null ? ` · Fehler ${status}` : ''}.{' '}
          {errorMessage(error)}
        </span>
      </Banner>
    </AuthFrame>
  );
}
